import Fetch from '../models/Fetch';

class Forum {
  fetch;

  static {
    this.fetch = new Fetch();
  }

  static save(data) {
    this.fetch.endpoint = 'forums';
    this.fetch.method = 'POST';
    this.fetch.body = data;

    return this.fetch.performRequest();
  }

  static show(id) {
    this.fetch.endpoint = `forums/${id}`;
    this.fetch.method = 'GET';

    return this.fetch.performRequest();
  }

  static get(search, page, paginate, limit, title) {
    this.fetch.endpoint = 'forums';
    this.fetch.method = 'GET';

    search && this.fetch.queries.set('name', search);
    page && this.fetch.queries.set('page', page);
    limit && this.fetch.queries.set('limit', limit);
    title && this.fetch.queries.set('title', title);
    paginate === false && this.fetch.queries.set('paginate', paginate);

    return this.fetch.performRequest();
  }

  static update(id, data) {
    this.fetch.endpoint = `forums/${id}`;
    this.fetch.method = 'PUT';
    this.fetch.body = data;

    return this.fetch.performRequest();
  }

  static delete(id) {
    this.fetch.endpoint = `forums/${id}`;
    this.fetch.method = 'DELETE';

    return this.fetch.performRequest();
  }

  static reply(id, reply) {
    this.fetch.endpoint = `forums/${id}/replies`;
    this.fetch.method = 'POST';
    this.fetch.body = reply;

    return this.fetch.performRequest();
  }

  static deleteReply(forumId, replyId) {
    this.fetch.endpoint = `forums/${forumId}/replies/${replyId}`;
    this.fetch.method = 'DELETE';

    return this.fetch.performRequest();
  }

  static updateReply(forumId, replyId, reply) {
    this.fetch.endpoint = `forums/${forumId}/replies/${replyId}`;
    this.fetch.method = 'PUT';
    this.fetch.body = reply;

    return this.fetch.performRequest();
  }
}

export default Forum;
